import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as responsive } from 'react-responsive-redux';

import screen from './screen';
import partialRepayment from './partialRepayment';
import guaranteedInheritance from './guaranteedInheritance';

const reducers = {
  router, responsive, screen, partialRepayment, guaranteedInheritance
};
const rootReducer = combineReducers(reducers);
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js